import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';

const ServiceList = () => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchServices = async () => {
            setLoading(true);
            try {
                const res = await axios.get('https://local-technician-finder-backend.onrender.com/api/services');
                setServices(res.data);
            } catch (err) {
                console.error(err);
                setError('Failed to fetch services.');
            } finally {
                setLoading(false);
            }
        };
        fetchServices();
    }, []);

    if (loading) return <LoadingSpinner />;
    if (error) return <div>{error}</div>;

    return (
        <div className="container mt-4">
            <h1 className="mb-4 text-center">Available Services</h1>
            {services.length === 0 ? (
                <p className="text-center">No services found.</p>
            ) : (
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2">
                    {services.map(service => (
                        <div className="col" key={service._id}>
                            <div className="card h-100 shadow-sm">
                                <div className="card-body d-flex flex-column p-2">
                                    <h5 className="card-title mb-1">{service.name}</h5>
                                    <p className="card-text flex-grow-1 mb-1">{service.description}</p>
                                    <div className="mt-auto">
                                        <Link to={`/technicians/service/${service.name}`} className="btn btn-primary btn-sm">View Technicians</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ServiceList;